export const deferredRequest = <T>(request: Promise<T>, millisec: number) => {
  const p = new Promise((resolve) => {
    setTimeout(() => {
      resolve(millisec)
    }, millisec)
  })
  return Promise.all([request, p]).then(([res]) => res)
}
